module.exports = __webpack_public_path__ + "static/media/campus_24.e18d44f4.jpg";